<template>
    <div>
        <v-row
            @mouseenter="hover = true"
            @mouseleave="hover = false"
            @click.self="expanded = !expanded"
            class="mx-0 meeting"
            :class="{ 'expanded' : expanded }"
            align="center">
                <v-col cols="1" class="text-center" @click.self="expanded = !expanded">
                    <v-icon :color="changedValues.type ? 'primary' : undefined" @click="toggleType()">
                        {{ $store.state.meetings.typeMap[meeting.type] }}
                    </v-icon>
                </v-col>
                <v-col cols="2" class="text-center" @click.self="expanded = !expanded">
                    {{ fullName(meeting) }}
                </v-col>
                <v-col cols="1" class="text-center" :class="{'changed' : changedValues.phone}" @click.self="expanded = !expanded">
                    <v-text-field v-model="meeting.phone" />
                </v-col>
                <v-col cols="2" class="text-center" :class="{'changed' : changedValues.meetingDate}" @click.self="expanded = !expanded">
                    <date-picker
                        :date="meeting.meetingDate"
                        @updateDate="meeting.meetingDate = $event"
                    />
                </v-col>
                <v-col cols="1" class="text-center" :class="{'changed' : changedValues.meetingTime}" @click.self="expanded = !expanded">
                    <v-text-field v-model="meeting.meetingTime" />
                </v-col>
                <v-col cols="3" class="text-center" :class="{'changed' : changedValues.salesAgent}" @click.self="expanded = !expanded">
                    <v-autocomplete
                        :disabled="$store.state.main.access === 'tele'"
                        v-model="meeting.salesAgent"
                        :items="$store.state.meetings.salesAgents" />
                </v-col>
                <v-col cols="2" class="text-center" :class="{'changed' : changedValues.status}" @click.self="expanded = !expanded">
                    <v-select :items="$store.state.meetings.statuses" v-model="meeting.status" @change="setStatus" />
                </v-col>
                <div :class="{ 'hidden' : !expanded }" style="display: flex; width: 100%">
                    <v-col cols="1" />
                    <v-col cols="9" :class="{'changed' : changedValues.comment}">
                        <v-textarea rows="7" outlined auto-grow label="Kommentar" v-model="meeting.comment" :error-messages="$store.state.meetings.errors.comment" />
                    </v-col>
                    <v-col cols="2" style="position: relative">
                        {{ meeting.rebookPermission }}
                        <v-select
                            label="Årsag"
                            v-if="meeting.status === 'canceled'"
                            :items="$store.state.meetings.reBookPermissions"
                            v-model="meeting.reBookPermission"
                            :color="changedValues.reBookPermission ? 'primary' : undefined"
                            :class="{'changed' : changedValues.reBookPermission}"
                            :error-messages="$store.state.meetings.errors.reBookPermission"
                        />
                        <v-select
                            label="Resultat"
                            v-if="meeting.status === 'completed'"
                            :items="$store.state.meetings.results"
                            v-model="meeting.result"
                            :color="changedValues.result ? 'primary' : undefined"
                            :class="{'changed' : changedValues.result}"
                            :error-messages="$store.state.meetings.errors.result"
                        />
                        <date-picker
                            label="Opfølgningsdato"
                            v-if="meeting.result === 'offer'"
                            :date="meeting.offerClosedDate"
                            @updateDate="meeting.offerClosedDate = $event"
                            :class="{'changed' : changedValues.result}"
                        />
                        <v-text-field
                            type="number"
                            label="Solgt præmie"
                            v-if="meeting.status === 'completed' && meeting.result === 'sale'"
                            v-model="meeting.value"
                            :color="changedValues.value ? 'primary' : undefined"
                            :class="{'changed' : changedValues.value}"
                            :error-messages="$store.state.meetings.errors.value"
                        />
                        <div
                            v-if="['admin', 'all'].includes(access)"
                            class="d-flex align-center"
                            style="position: absolute; right: 15px; bottom: 38px; cursor: pointer"
                            @click="deleteMeetingDialog = true"
                        >
                            <v-btn text color="red">
                                <v-icon left>fa-times</v-icon>
                                slet møde
                            </v-btn>
                        </div>
                    </v-col>
                </div>
                <v-btn v-if="hover" small fab class="expand-meeting-button" @click="expanded = !expanded">
                    <v-icon v-if="expanded">fa-angle-up</v-icon>
                    <v-icon v-else>fa-angle-down</v-icon>
                </v-btn>
        </v-row>
        <v-dialog v-model="deleteMeetingDialog" width="500">
            <v-card>
                <v-card-title>Slet møde</v-card-title>
                <v-card-text>Er du sikker på at du vil slette mødet?</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn text color="red" @click="deleteMeetingDialog = false">Annuller</v-btn>
                    <v-btn text color="green" @click="confirmDeleteMeeting">Bekræft</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import moment from 'moment'
import DatePicker from '@/components/datePicker.vue'

export default {
    components: {
        DatePicker
    },
    props: [
        'initialMeeting',
        'agents'
    ],
    data () {
        return {
            meeting: {...this.initialMeeting},
            hover: false,
            expanded: false,
            datePicker: false,
            changedValues: Object.keys(this.initialMeeting).reduce((o, key) => ({ ...o, [key]: false}), {}),
            deleteMeetingDialog: false
        }
    },
    computed: {
        access () {
            return this.$store.state.main.access
        }
    },
    methods: {
        toggleType () {
            if (this.meeting.type === 'tele') this.meeting.type = 'physical'
            else if (this.meeting.type === 'physical') this.meeting.type = 'online'
            else if (this.meeting.type === 'online') this.meeting.type = 'tele'
        },
        changeDate (meeting) {
            return meeting.meetingDate ? moment(meeting.meetingDate).format('D. MMMM YYYY') : null
        },
        setStatus (status) {
            if (status !== 'completed') this.meeting.result = null
            this.expanded = true
        },
        fullName (meeting) {
            return (meeting.firstname ? meeting.firstname.split(' ')[0] : '') + ' ' + (meeting.lastname ? meeting.lastname.split(' ')[meeting.lastname.split(' ').length - 1] : '')
        },
        async confirmDeleteMeeting () {
            await this.$http().delete(`booking/registration/meetings/${this.meeting.id}`)
            this.$emit('meetingDeleted')
        }
    },
    watch: {
        meeting: {
            handler () {
                Object.keys(this.meeting).forEach(key => {
                    if (this.initialMeeting[key] !== this.meeting[key]) this.changedValues[key] = true
                    else this.changedValues[key] = false
                })
                this.$store.state.meetings.updatedMeetings[this.meeting.id] = this.meeting
                this.$store.state.meetings.changedMeetings = true
            },
            deep: true
        }
    }
}
</script>